/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_CertificateInputs */

const en__field_certificate = /** @type {(inputs: _Field_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificate`)
};

const de__field_certificate = /** @type {(inputs: _Field_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zertifikat`)
};

/**
* | output |
* | --- |
* | "Certificate" |
*
* @param {_Field_CertificateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_certificate = /** @type {((inputs?: _Field_CertificateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_CertificateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_certificate(inputs)
	return de__field_certificate(inputs)
});